module.exports = __webpack_public_path__ + "img/yqgk@2x.bc1e5831.png";